<template>
  <div id="app">
    <div v-if="authUser == null && $route.name !== 'Login'">
      <div class="d-flex justify-content-center align-items-center" style="height: 100vh;">
          <fingerprint-spinner
            :animation-duration="1500"
            :size="128"
            color="#ff1d5e"
          />
    </div>
    </div>
    <Maintenance v-else-if="showMaintenance" />
    <template v-else>
      <router-view />
      <SharedAccountsModal />
    </template>
    <div v-if="showOfflineOverlay" class="app-offline-overlay">
      <div class="app-offline-card">
        <b-spinner small class="mr-2"></b-spinner>
        <div class="app-offline-text">
          <div class="app-offline-title">Server offline</div>
          <div class="app-offline-subtitle">
            {{ reconnecting > 0 ? 'Trying to reconnect…' : 'Connecting to server…' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import { FingerprintSpinner } from 'epic-spinners'
import SharedAccountsModal from './components/SharedAccountsModal'
import Maintenance from './views/pages/Maintenance'

export default {
  name: 'app',
  computed: {
    ...mapGetters(['isConnected', 'authUser', 'reconnecting', 'wasConnected']),
    showOfflineOverlay () {
      return !this.isConnected && this.wasConnected && (this.authUser || this.reconnecting > 0)
    },
    showMaintenance () {
      return this.authUser && this.authUser !== false && this.authUser.maintenance && !this.hasPermission('MaintenanceBypass')
    }
  },
  components: {
    FingerprintSpinner,
    SharedAccountsModal,
    Maintenance
  }
}
</script>

<style>
  /* Import Font Awesome Icons Set */
  @import '~flag-icon-css/css/flag-icon.min.css';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/css/font-awesome.min.css';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/css/simple-line-icons.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
</style>
<style lang="scss">
  // Import Main styles for this application
  @import './scss/style';

  .app-offline-overlay {
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(8, 12, 16, 0.6);
    z-index: 9999;
  }

  .app-offline-card {
    display: flex;
    align-items: center;
    padding: 14px 18px;
    background: rgba(10, 14, 20, 0.9);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
    color: #f1f3f5;
    font-size: 14px;
  }

  .app-offline-text {
    display: flex;
    flex-direction: column;
  }

  .app-offline-title {
    font-weight: 700;
    letter-spacing: 0.2px;
  }

  .app-offline-subtitle {
    color: rgba(255, 255, 255, 0.65);
    font-size: 12px;
  }
</style>

